import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { OidcProvider } from 'redux-oidc';
import { processSilentRenew } from 'redux-oidc';
import * as serviceWorker from './serviceWorker';
import RootElement from 'containers/root';
import store from 'utils/configureStore';
import userManager from 'utils/userManager';
import { getUrlVars } from 'utils/utilities';
import { userUnloaded, userModuleAccessCleared } from 'reducers/userReducer';
import 'bootstrap/dist/css/bootstrap.min.css'; // make sure full Bootstrap is imported

// register the protocol handler
if (window.location.host === 'app.workaware.com' && navigator.registerProtocolHandler) {
  navigator.registerProtocolHandler("web+workaware",
    `https://app.workaware.com/external?link=%s`,
    "Workaware Link Handler");
}

// silent_redirect_uri is path-style (/${host}/entryPoint=silentRenew) so check
// pathname directly rather than relying on getUrlVars which only reads query params.
const isSilentRenewFrame = window.location.pathname.includes('entryPoint=silentRenew');
const vars = isSilentRenewFrame
  ? { entryPoint: 'silentRenew' }
  : getUrlVars({ 'entryPoint': 'default' });

userManager.startSilentRenew();

// When the access token expires or silent renew fails, clear Redux state immediately
// so the sidebar and protected UI disappear, then redirect to the login page.
const handleSessionEnd = () => {
  store.dispatch(userUnloaded());
  store.dispatch(userModuleAccessCleared());
  userManager.removeUser().then(() => {
    window.location.replace('/');
  });
};

// accessTokenExpired: do NOT log out immediately — let automaticSilentRenew use the
// refresh token first. If renewal fails, silentRenewError fires and we log out then.
// Premature logout here was the root cause of Bugs 03, 22, 29, 41.
userManager.events.addSilentRenewError(handleSessionEnd);

// process a ticket renewal
if (vars.entryPoint === 'silentRenew') {
  processSilentRenew();

  // main application entry point
} else {
  ReactDOM.render(
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <RootElement />
      </OidcProvider>
    </Provider>,
    document.getElementById('root')
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}